var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenchmarkJob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2498 4.67298H13.4165L13.4165 11.0897C13.4165 11.7372 12.8973 12.2563 12.2498 12.2563L2.33317 12.2563V11.0897L12.2498 11.0897L12.2498 4.67298Z",
    fill: "#29AA57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.49984 2.33965V1.17298C3.49984 0.531317 4.02484 0.00631714 4.6665 0.00631714L6.99984 0.00631714C7.6415 0.00631714 8.1665 0.531317 8.1665 1.17298V2.33965H11.0832V8.75632C11.0832 9.39798 10.5582 9.92298 9.9165 9.92298L1.74984 9.92298C1.10817 9.92298 0.58317 9.39798 0.58317 8.75632L0.58317 2.33965L3.49984 2.33965ZM6.99984 1.17298L4.6665 1.17298V2.33965H6.99984V1.17298ZM1.74984 8.75632L9.9165 8.75632V3.50632L1.74984 3.50632L1.74984 8.75632Z",
    fill: "#29AA57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenchmarkJob);
export default __webpack_public_path__ + "static/media/benchmark-job.98fa38586d6fe5c50bafcfb710c4ec30.svg";
export { ForwardRef as ReactComponent };